// extracted by mini-css-extract-plugin
export default {"pageInfo":"page-info_pageInfo__uHioQ","icon":"page-info_icon__aB2EV","title":"page-info_title__kTV9S"};